// extracted by mini-css-extract-plugin
export var orderDetails = "_p8-2";
export var orderImage = "_p8-1";
export var orderMeta = "_p8-3";
export var orderSummary = "_p8-0";
export var rightArrow = "_p8-4";